import { useState } from 'react';
import { RefreshCw } from 'lucide-react';

const RefreshButton = ({ onRefresh }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [lastRefresh, setLastRefresh] = useState(null);

  const handleRefresh = async () => {
    // Protecție împotriva click-urilor multiple
    if (isRefreshing) return;

    // Protecție timp - nu permite refresh mai des de o dată la 2 secunde
    const now = Date.now();
    if (lastRefresh && (now - lastRefresh) < 2000) {
      return;
    }

    try {
      setIsRefreshing(true);
      setLastRefresh(now);
      
      // Aici apelezi funcția de refresh
      await onRefresh();
      
    } catch (error) {
      console.error('Eroare la refresh:', error);
    } finally {
      // Delay minim pentru feedback vizual
      setTimeout(() => {
        setIsRefreshing(false);
      }, 500);
    }
  };

  return (
    <button
      onClick={handleRefresh}
      disabled={isRefreshing}
      className={`
        inline-flex items-center px-4 py-2 rounded-lg font-medium text-sm
        transition-all duration-200 transform
        ${isRefreshing 
          ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
          : 'bg-blue-50 text-blue-600 hover:bg-blue-100 hover:scale-105 active:scale-95'
        }
        border border-blue-200 shadow-sm
      `}
      title={isRefreshing ? 'Se actualizează...' : 'Actualizează transporturile'}
    >
      <RefreshCw 
        className={`w-4 h-4 mr-2 ${isRefreshing ? 'animate-spin' : ''}`} 
      />
      {isRefreshing ? 'Se actualizează...' : 'Actualizează'}
    </button>
  );
};

export default RefreshButton;